<template>
	<v-container fluid class="p-absolute fill-height">
		<v-row class="ma-0 pa-0 fill-height p-relative d-flex flex-nowrap">
			<v-flex style="max-width: 160px; min-width: 160px">
				<v-item-group>
					<v-item>
						<v-spacer />
					</v-item>
				</v-item-group>
			</v-flex>
			<v-flex style="min-width: 162px; max-width: 400px"
			        v-for="(item, i) in listaDatas"
			        :key="i"
			        class="bordered-col pa-0 justify-start"
			/>
			<v-container style="width: 20px"></v-container>
<!--&lt;!&ndash; ESPAÇO DA DIREITA &ndash;&gt;-->
<!--			<div style="width: 36px" class="pa-0"/>-->
		</v-row>
	</v-container>
</template>
<script>
export default {
	name: 'colunas-data',
	props: {
		listaDatas: {},
	}
}
</script>
<style scoped lang="scss">

.bordered-col {
  position: relative;

  &::before {
    pointer-events: none;
    display: block;
    position: absolute;
    z-index: 3;
    content: "";
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border: 1px #bdccca solid !important;
    border-right: 1px #bdccca solid !important;
	  border-radius: 20px;
	  box-sizing: border-box;
  }
}
</style>